<div>
  <p-dialog
    #searchModal
    [(visible)]="isShowSearchModal"
    [maximizable]="true"
    [responsive]="true"
    [showHeader]="false"
    [draggable]="false"
    [resizable]="false"
    [transitionOptions]="'0ms'"
    (onShow)="initModalMaximized(searchModal)"
  >
    <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
      <!-- 헤더 시작 -->
      <!-- (input)="updateSearch($event)" -->
      <section class="header-modal">
        <div class="inner-search">
          <input type="search" #Keyword formControlName="keyword" [placeholder]="'SEARCH.SEARCH_TITLE' | t" />
          <a (click)="onClearSearch()"><img src="/assets/images/ico_search_cancel.svg" alt="search-cancel" /></a>
        </div>
        <a (click)="onCloseSearchModal()" class="button-close-search" [innerHTML]="'BUTTON.CANCEL' | t">Cancel</a>
        <!--
        <button (click)="onCloseSearchModal()" class="button-close-search" *ngIf="!isSearching">Cancel</button>
        <input type="submit" class="send active" *ngIf="isSearching" value="SEND" />
        -->
      </section>

      <!-- 검색 입력 전 노출 박스-->
      <section class="search-default-box" *ngIf="!isSearching">
        <ul class="tab-search-before">
          <li
            [class.active]="searchMode === SEARCH_MODE.RECENT"
            (click)="searchMode = SEARCH_MODE.RECENT"
            [innerHTML]="'SEARCH.RECENT' | t"
          >
            Recent
          </li>
          <li
            [class.active]="searchMode === SEARCH_MODE.TREND"
            (click)="searchMode = SEARCH_MODE.TREND"
            [innerHTML]="'SEARCH.TREND' | t"
          >
            Trend
          </li>
        </ul>
        <div class="list-recent" [class.active]="searchMode === SEARCH_MODE.RECENT">
          <ul *ngIf="recentSearches && recentSearches.length > 0">
            <li *ngFor="let recentSearch of recentSearches; let i = index">
              <a (click)="onClickKeyword(recentSearch, false)">{{ recentSearch }}</a>
              <button type="button" (click)="removeItems($event, i)">
                <img src="/assets/images/btn_close01.svg" />
              </button>
            </li>
            <div class="clear-all">
              <span (click)="clearAllItems()" [innerHTML]="'BUTTON.CLEAR_ALL' | t">Clear All</span>
            </div>
          </ul>

          <!-- 최근 리스트 없을 경우 노출되는 텍스트 -->
          <p
            class="text-nolist"
            *ngIf="!recentSearches || recentSearches.length === 0"
            [innerHTML]="'SEARCH.NOTHING' | t"
          >
            There are no recent searches.<br />
            Search for a Product.
          </p>
        </div>

        <div class="list-trend" [class.active]="searchMode === SEARCH_MODE.TREND">
          <ul>
            <li *ngFor="let popularSearch of popularSearches; let i = index">
              <span [class.top3]="3 > i">{{ i + 1 }}</span>
              <a (click)="onClickKeyword(popularSearch.keyword, true)">{{ popularSearch.keyword }}</a>
            </li>
          </ul>
        </div>
      </section>
      <!-- 검색 입력 동안 노출 박스-->
      <section class="search-focus-box" *ngIf="isSearching">
        <ul
          *ngIf="
            isSearchingLists &&
            isSearchingLists.length > 0 &&
            this.searchForm.get('keyword').value &&
            this.searchForm.get('keyword').value.length > 2
          "
        >
          <li *ngFor="let brand of brandsType | slice: 0:3">
            <span>{{ brand.searchType }}</span>
            <!-- [routerLink]="['/brand', brand.item.id]" -->
            <a
              (click)="onCloseSearchModal(SEARCH_TYPE.BRAND, brand.item.id)"
              [innerHTML]="brand.item.englishName | highlight: searchForm.get('keyword').value"
              >{{ brand.item.englishName }}
            </a>
          </li>
          <!-- [routerLink]="['/product', product.item.id]"  -->
          <li
            *ngFor="let product of productType | slice: 0:10; let i = index"
            class="ga-ee-product-impression"
            [attr.data-name]="product.item.englishName"
            [attr.data-id]="product.item.id"
            [attr.data-price]="$any(product.item).mapperSaleProducts[0].productOption.salePriceUSD"
            [attr.data-brand]="$any(product.item).brand.englishName"
            [attr.data-variant]="$any(product.item).mapperSaleProducts[0].productOption.englishOptionName"
            [attr.data-position]="i"
            [attr.data-category]="$any(product.item).salesCategoryCode | categoryName"
            [attr.data-list]="'Preview Product'"
          >
            <!-- [attr.data-category]="'Searching'"
            [attr.data-list]="'Preview Product'" -->
            <a
              (click)="onCloseSearchModal(SEARCH_TYPE.PRODUCT, product.item.id)"
              [innerHTML]="product.item.englishName | highlight: searchForm.get('keyword').value"
              >{{ product.item.englishName }}
            </a>
          </li>
        </ul>
        <div class="text-nolist" *ngIf="!(brandsType && brandsType?.length) && !(productType && productType?.length)">
          <span [innerHTML]="'SEARCH.NO_RESULT' | t">
            No results that match your search.
          </span>
          <a
            [innerHTML]="'BUTTON.REQUEST_SUPPLY' | t"
            *ngIf="searchForm.get('keyword').value && searchForm.get('keyword').value.length >= 5"
            (click)="inquiry.open()"
            >입고요청</a
          >
        </div>
      </section>
    </form>
  </p-dialog>
</div>

<app-inquiry #inquiry [type]="INQUIRY_TYPE.PRODUCT" [isRequestProduct]="true"></app-inquiry>
